import { PaymentPlanViewModel } from 'src/common/models';

import { adaptFeeMessagesForPaymentPlan } from './fee-messages-adapter';
import { DateFragment, DateInput, PriceDetailsFragment, PropertyPaymentModel, PropertyPaymentType } from 'src/common/__generated__/api';

export const adaptPaymentPlans = (priceDetails: PriceDetailsFragment.Fragment[]): PaymentPlanViewModel[] | undefined =>
  priceDetails?.map(priceDetail => adaptPaymentPlan(priceDetail, priceDetails.length > 1));

export const adaptPaymentPlan = (priceDetail: PriceDetailsFragment.Fragment, multiplePaymentPlans?: boolean): PaymentPlanViewModel => {
  const loyaltyEarnAwardsMessage = adaptEarnAwardsMessage(priceDetail);
  const feeMessages = adaptFeeMessagesForPaymentPlan(priceDetail);
  const payLater = adaptPayLater(priceDetail);
  const paymentType = adaptPaymentType(priceDetail.paymentModel);

  return {
    loyaltyEarnAwardsMessage,
    offerBookButton: multiplePaymentPlans ? priceDetail.offerBookButton : null,
    inventoryType: priceDetail.propertyNaturalKeys?.[0].inventoryType,
    feeMessages,
    payLater,
    noCreditCardRequired: priceDetail.noCreditCard,
    installmentPayable: priceDetail.installmentPayable,
    displayPrice: priceDetail.price?.lead?.formatted,
    totalPriceMessage: priceDetail.totalPriceMessage,
    deposit: priceDetail.deposit?.formatted,
    paymentType,
    hotelCollect: priceDetail.hotelCollect,
    numberOfNightsAndRoomsMessage: priceDetail.price?.roomNightMessage,
    priceMessaging: priceDetail.price?.priceMessaging,
    etpModalPolicies: priceDetail.etpModalPolicies,
    checkInDate: priceDetail.propertyNaturalKeys?.[0].checkIn.shortDateFormat,
    checkOutDate: priceDetail.propertyNaturalKeys?.[0].checkOut.shortDateFormat,
    multiItemPriceToken: priceDetail.price?.multiItemPriceToken,
    ratePlanType: priceDetail.propertyNaturalKeys?.[0].ratePlanType,
    checkInDateInput: adaptDateInput(priceDetail.propertyNaturalKeys?.[0].checkIn),
    checkOutDateInput: adaptDateInput(priceDetail.propertyNaturalKeys?.[0].checkOut),
  } as PaymentPlanViewModel;
};

function adaptDateInput(dateFragment: DateFragment.Fragment): DateInput {
  if (dateFragment) {
    return { day: dateFragment.day, month: dateFragment.month, year: dateFragment.year };
  }
}

export const adaptEarnAwardsMessage = (priceDetail: PriceDetailsFragment.Fragment) => priceDetail?.loyaltyMessage?.value;

export const adaptPayLater = (priceDetail: PriceDetailsFragment.Fragment) =>
  priceDetail.paymentModel ? priceDetail.paymentModel !== PropertyPaymentModel.PAY_NOW : null;

export const adaptPaymentType = (paymentModel: PropertyPaymentModel): PropertyPaymentType => PropertyPaymentType[paymentModel];
